import React, {useEffect, useMemo, useRef, useState} from "react";
import Tabs from "../../../components/Tabs";
import {useDispatch, useSelector} from "react-redux";
import {Colors} from "../../../assets/colors/Colors";
import SelectForm from "../../../components/ComponentesFormularios/SelectForm";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import RadioButtonForm from "../../../components/ComponentesFormularios/RadioButtonForm";
import {CalendarForm} from "../../../components/ComponentesFormularios/CalendarForm";
import Tooltip from "@mui/material/Tooltip";
import {modalCRUDService} from "../../../services/modalCRUDService";
import {FormProvider, useForm, useFormContext, useWatch} from "react-hook-form";
import {
  convertToString, generateGenericNameImage, getDateTime,
  getDiasVisitaEntregaVector,
  getDigitoVerificacion, getItemsState,
  nombrePropio, validarEspaciosEnBlanco, validArray,
  validObjectKeys
} from "../../../util/functions";
import {isArray, isEmpty, isObject} from "../../../util/is";
import {clientesService} from "../../../services/apiClientes";
import {GlobalConstants} from "../../../data/GlobalConstants";
import GeneradorDirecciones from "../../../components/ComponentesFormularios/GeneradorDireccionesForm";
import empresa from "../../../assets/images/empresa.png";
import CustomSwitch, {validStateChecked} from "../../../components/Switch";
import {ModalCRUD} from "../../../components/ModalCRUD";
import userGenericAvatar from '../../../assets/images/emptyuserphoto.png';
import {
  classResponsiveFormWithoutPaddingX,
  ERROREMAILFIELDREQUIRED,
  ERRORFIELDREQUIRED, optionsTiposDocumento
} from "../../../data/ConstantForm";
import { classResponsiveForm, classResponsiveFormWidthHeader,
classResponsiveFormDoubleWidth, optionsEstados } from "../../../data/ConstantForm";
import NestedInputForm from "../../../components/ComponentesFormularios/NestedInputForm";
import Emitter from "../../../EventEmitter/EventEmitter";
import {ConstantEventEmitter} from "../../../data/ConstantEventEmitter";
import {alertQuestionService} from "../../../services/alertQuestionService";
import NestedSelectVirtualizeForm from "../../../components/ComponentesFormularios/NestedSelectVirtualizeForm";
import SelectFormVirtualize from "../../../components/ComponentesFormularios/SelectFormVirtualize";
import {ConstantsFormCrud} from "../../../data/RoutesFormCrud";
import CheckBox from "../../../components/ComponentesFormularios/CheckBox";
import {useDropzone} from 'react-dropzone';
import Zoom from 'react-medium-image-zoom';


const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderBottom: "2px dashed #2196f3",
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

const activeStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};


export const HeaderClientInformation = ({infoCli}) => {

    const { handleSubmit, control, formState: { errors } } = useFormContext();

    return(
        <div className="d-flex align-items-center">

            <div className="ml-2">
                <img className="ml-2" style={{width: 100, height: 100, borderRadius: 100 / 2, border: `1px solid ${Colors.GRAY_LOW}` }} src={userGenericAvatar} alt="..."/>
            </div>

            <div className="px-3 py-2">
                <p className="p-0 m-0 font-weight-bold" style={{fontSize: "1.2em"}}>{isEmpty(infoCli?.razonSocial) ? "XXXX XXXX XXXX XXXX" : convertToString(infoCli.razonSocial).toUpperCase()}</p>
                <p className="p-0 m-0" style={{fontSize: "1em"}}>{`Doc. ${isEmpty(infoCli?.documento) ? "XXX-XXX-XXX" : infoCli.documento}`}</p>
                <p className="p-0 m-0" style={{fontSize: "1em"}}>{`Cod. Interno. ${isEmpty(infoCli?.idTercero) ? "XXX-XXX-XXX" : infoCli?.idTercero}`}</p>
            </div>

        </div>
    )

}

const DiasVisitaEntregaView = ({diasOrdenVisita, diasOrdenEntrega}) => {

    return(
        <div>
            <div className="row align-items-center justify-content-center mt-0">
                <div className="text-center p-1"><p className="mb-1"><strong>LU</strong></p>
                    <div className="d-flex align-items-center justify-content-center">
                        {
                            isEmpty(diasOrdenVisita.dias[0]) || diasOrdenVisita.dias[0] === -1 ?
                                <div className="circulo-big-indicador-gray d-flex align-items-center justify-content-center mr-1"/>
                                :
                                <div className="circulo-big-indicador-visita mr-1">{diasOrdenVisita.orden[0]}</div>
                        }
                    </div>
                </div>
                <div className="text-center p-1"><p className="mb-1"><strong>MA</strong></p>
                    <div className="d-flex align-items-center justify-content-center">
                        {
                            isEmpty(diasOrdenVisita.dias[1]) || diasOrdenVisita.dias[1] === -1 ?
                                <div className="circulo-big-indicador-gray d-flex align-items-center justify-content-center mr-1"/>
                                :
                                <div className="circulo-big-indicador-visita mr-1">{diasOrdenVisita.orden[1]}</div>
                        }
                    </div>
                </div>
                <div className="text-center p-1"><p className="mb-1"><strong>MI</strong></p>
                    <div className="d-flex align-items-center justify-content-center">
                        {
                            isEmpty(diasOrdenVisita.dias[2]) || diasOrdenVisita.dias[2] === -1 ?
                                <div className="circulo-big-indicador-gray d-flex align-items-center justify-content-center mr-1"/>
                                :
                                <div className="circulo-big-indicador-visita mr-1">{diasOrdenVisita.orden[2]}</div>
                        }
                    </div>
                </div>
                <div className="text-center p-1"><p className="mb-1"><strong>JU</strong></p>
                    <div className="d-flex align-items-center justify-content-center">
                        {
                            isEmpty(diasOrdenVisita.dias[3]) || diasOrdenVisita.dias[3] === -1 ?
                                <div className="circulo-big-indicador-gray d-flex align-items-center justify-content-center mr-1"/>
                                :
                                <div className="circulo-big-indicador-visita mr-1">{diasOrdenVisita.orden[3]}</div>
                        }
                    </div>
                </div>
                <div className="text-center p-1"><p className="mb-1"><strong>VI</strong></p>
                    <div className="d-flex align-items-center justify-content-center">
                        {
                            isEmpty(diasOrdenVisita.dias[4]) || diasOrdenVisita.dias[4] === -1 ?
                                <div className="circulo-big-indicador-gray d-flex align-items-center justify-content-center mr-1"/>
                                :
                                <div className="circulo-big-indicador-visita mr-1">{diasOrdenVisita.orden[4]}</div>
                        }
                    </div>
                </div>
                <div className="text-center p-1"><p className="mb-1"><strong>SA</strong></p>
                    <div className="d-flex align-items-center justify-content-center">
                        {
                            isEmpty(diasOrdenVisita.dias[5]) || diasOrdenVisita.dias[5] === -1 ?
                                <div className="circulo-big-indicador-gray d-flex align-items-center justify-content-center mr-1"/>
                                :
                                <div className="circulo-big-indicador-visita mr-1">{diasOrdenVisita.orden[5]}</div>
                        }
                    </div>
                </div>
                <div className="text-center p-1"><p className="mb-1"><strong>DO</strong></p>
                    <div className="d-flex align-items-center justify-content-center">
                        {
                            isEmpty(diasOrdenVisita.dias[6]) || diasOrdenVisita.dias[6] === -1 ?
                                <div className="circulo-big-indicador-gray d-flex align-items-center justify-content-center mr-1"/>
                                :
                                <div className="circulo-big-indicador-visita mr-1">{diasOrdenVisita.orden[6]}</div>
                        }
                    </div>
                </div>
            </div>
            <div className="row align-items-center justify-content-center mt-0">
                <div className="text-center p-1">
                    <div className="d-flex align-items-center justify-content-center">
                        {
                            isEmpty(diasOrdenEntrega.dias[0]) || diasOrdenEntrega.dias[0] === -1 ?
                                <div className="circulo-big-indicador-gray d-flex align-items-center justify-content-center mr-1"/>
                                :
                                <div className="circulo-big-indicador-entrega mr-1">{diasOrdenEntrega.orden[0]}</div>
                        }
                    </div>
                </div>
                <div className="text-center p-1">
                    <div className="d-flex align-items-center justify-content-center">
                        {
                            isEmpty(diasOrdenEntrega.dias[1]) || diasOrdenEntrega.dias[1] === -1 ?
                                <div className="circulo-big-indicador-gray d-flex align-items-center justify-content-center mr-1"/>
                                :
                                <div className="circulo-big-indicador-entrega mr-1">{diasOrdenEntrega.orden[1]}</div>
                        }
                    </div>
                </div>
                <div className="text-center p-1">
                    <div className="d-flex align-items-center justify-content-center">
                        {
                            isEmpty(diasOrdenEntrega.dias[2]) || diasOrdenEntrega.dias[2] === -1 ?
                                <div className="circulo-big-indicador-gray d-flex align-items-center justify-content-center mr-1"/>
                                :
                                <div className="circulo-big-indicador-entrega mr-1">{diasOrdenEntrega.orden[2]}</div>
                        }
                    </div>
                </div>
                <div className="text-center p-1">
                    <div className="d-flex align-items-center justify-content-center">
                        {
                            isEmpty(diasOrdenEntrega.dias[3]) || diasOrdenEntrega.dias[3] === -1 ?
                                <div className="circulo-big-indicador-gray d-flex align-items-center justify-content-center mr-1"/>
                                :
                                <div className="circulo-big-indicador-entrega mr-1">{diasOrdenEntrega.orden[3]}</div>
                        }
                    </div>
                </div>
                <div className="text-center p-1">
                    <div className="d-flex align-items-center justify-content-center">
                        {
                            isEmpty(diasOrdenEntrega.dias[4]) || diasOrdenEntrega.dias[4] === -1 ?
                                <div className="circulo-big-indicador-gray d-flex align-items-center justify-content-center mr-1"/>
                                :
                                <div className="circulo-big-indicador-entrega mr-1">{diasOrdenEntrega.orden[4]}</div>
                        }
                    </div>
                </div>
                <div className="text-center p-1">
                    <div className="d-flex align-items-center justify-content-center">
                        {
                            isEmpty(diasOrdenEntrega.dias[5]) || diasOrdenEntrega.dias[5] === -1 ?
                                <div className="circulo-big-indicador-gray d-flex align-items-center justify-content-center mr-1"/>
                                :
                                <div className="circulo-big-indicador-entrega mr-1">{diasOrdenEntrega.orden[5]}</div>
                        }
                    </div>
                </div>
                <div className="text-center p-1">
                    <div className="d-flex align-items-center justify-content-center">
                        {
                            isEmpty(diasOrdenEntrega.dias[6]) || diasOrdenEntrega.dias[6] === -1 ?
                                <div className="circulo-big-indicador-gray d-flex align-items-center justify-content-center mr-1"/>
                                :
                                <div className="circulo-big-indicador-entrega mr-1">{diasOrdenEntrega.orden[6]}</div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )

}

const CardsPuntoVenta = ({item: itemList, codTercero, onChangePuntoVenta, onAddPuntoVentaItem, infoCli, isEditing}) => {

    const dispatch = useDispatch();
    const authState = useSelector( state => state.auth )
    const { idUsuario } = authState;
    const [ item, setItem ] = useState(itemList);
    const [stateFilterCriterioPtoVenta, setStateFilterCriterioPtoVenta] = useState({
      checkActivos: false,
      checkInactivos: false
    });

    const handleEditarPuntoVenta = () => {

        clientesService.getPuntoVentaById( item.idPtoVenta ).then(
            response => {
                const {status, msg, data} = response;

                if (status) {

                    modalCRUDService.showModal({
                        props: {codTercero, idPuntoVenta: item.idPtoVenta, infoCli, data: validObjectKeys(data),
                            function: ({newState, item}) => onChangePuntoVenta({newState, item})},
                        type: ConstantsFormCrud.modalCRUDClientesPuntoVentaCRUD,
                        title: `Punto Venta #${item.idPtoVenta}`,
                        isAddMode: false,
                        isEditable: true,
                        dense: true,
                        id: `modalPuntoVenta`,
                        size: `xl`});

                } else {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
                }
            },
            error => {
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });
            }
        );

    }

    const handleChangeSwitchState = (name, checked) => {


      alertQuestionService.showAlert({title: `Cambio de estado #${item.idPtoVenta}`, question: `¿Estás seguro de cambiar el estado del registro?`,
        message: `Recuerda que al cambiar el estado del registro afectara las gestiones que asocien el registro seleccionado`,
        actionBtnAceptar: () => {

          clientesService.setStatePuntoVentaById({
            usrAuditoria: idUsuario,
            estado: checked ? 1 : 0,
            id: item.idPtoVenta
          }).then(
            response => {
              const {status, msg, data} = response;

              if (status) {

                let itemCopy = Object.assign({}, item);

                itemCopy.estado = checked ? 1 : 0;

                setItem(itemCopy);

                dispatch({type: 'setStateAlert', alert: {type: GlobalConstants.alertSuccess, message: msg}});

                alertQuestionService.clear();

              } else {
                dispatch({type: 'setStateAlert', alert: {type: GlobalConstants.alertError, message: msg}});
              }
            },
            error => {
              dispatch({type: 'setStateAlert', alert: {type: GlobalConstants.alertError, message: error.toString()}});
            }
          );

        },
        actionBtnCancelar: () => alertQuestionService.clear(),
        type: GlobalConstants.alertInfo
    });


    }

    const handleCreateNewRutaPtoVenta = () => {
        modalCRUDService.showModal({
            props: {data: {}, idPuntoVenta: item.idPtoVenta, infoCli, function: ({newState, idPtoVenta}) => onAddPuntoVentaItem({newState, idPtoVenta})},
            type: ConstantsFormCrud.modalCRUDClientesRutas,
            title: `Crear Ruta Para Punto Venta #${item.idPtoVenta}`,
            isAddMode: true,
            isEditable: true,
            dense: true,
            id: `modalCreateEditRutas`,
            size: `xl`});
    }

    const handleChangeFilter = ({name, checked}) => {

      let arrState = Object.assign({}, stateFilterCriterioPtoVenta);

      arrState[name] = checked;

      setStateFilterCriterioPtoVenta(arrState);

    }

    return(
        <>
          <div key={`cardPtoVenta${item.idPtoVenta}`} className="p-2 card-container-form-withoutCover withoutCover ">
              <div className="card w-100 mb-0" style={{height: 210}}>
                  <div className="principalContainerCardWithOutCover">
                      <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                          <div className="d-flex align-items-center">
                              <img className="m-2" style={{width: 100}} src={empresa} />
                              <div className="mr-2 ml-1 w-100 mw-100 my-1">
                                <div className="w-100 font-weight-bold my-1 text-overflow-card-punto-venta" style={{fontSize: "1.4rem"}}>{nombrePropio(item.txNegocio)}</div>
                                <div className="w-100 text-overflow-card-punto-venta-oneline" style={{lineHeight: 1.3}}> <span className="font-weight-bold mr-1">Cod. Punto:</span> {isEmpty(item.idPtoVenta) ? "XXXXXXX" : item.idPtoVenta}</div>
                                <div className="w-100 text-overflow-card-punto-venta" style={{lineHeight: 1.3}}> <span className="font-weight-bold mr-1">Dirección: </span>{`${isEmpty(item.direccion) ? "XXX XX XX XXXXXXXX" : convertToString(item.direccion).toUpperCase()} - ${isEmpty(item.txBarrio) ? "XXXXXXXX" : convertToString(item.txBarrio).toUpperCase()}`}</div>
                                <div className="w-100 text-overflow-card-punto-venta" style={{lineHeight: 1.3}}> <span className="font-weight-bold mr-1">Ciudad: </span>{ `${isEmpty(item.nmDepartamento) ? "XXXXXXXXX" : convertToString(item.nmDepartamento).toUpperCase()} - ${isEmpty(item.txCiudad) ? "XXXXXXXXX" : convertToString(item.txCiudad).toUpperCase()}`}</div>
                                <div className="w-100 text-overflow-card-punto-venta-oneline" style={{lineHeight: 1.3}}> <span className="font-weight-bold mr-1">Teléfono: </span> {`${isEmpty(item.telefono) ? "XXXXXXX" : item.telefono} - ${isEmpty(item.celular) ? "XXXXXXX" : item.celular}`}</div>
                              </div>
                          </div>
                          </div>

                          <div className="px-2 d-flex flex-column align-items-end">
                              <CustomSwitch disabled={!isEditing} name="estado" state={item.estado} handleChange={(name, checked) => handleChangeSwitchState(name, checked)}/>

                              <div className="d-flex align-items-center">
                                {
                                  isEditing ?
                                    <Tooltip className="mx-1" title="Editar Punto Venta" aria-label="editar-ptoVenta">
                                      <a onClick={() => handleEditarPuntoVenta()}
                                         className="icon-container-actions p-0 mx-1 d-flex">
                                        <div style={{backgroundColor: Colors.COLOR_BLUE_THEME}}/>
                                        <i style={{color: Colors.COLOR_BLUE_THEME}} className="fas fa-pen fa-2x"/>
                                      </a>
                                    </Tooltip>
                                    :
                                    <Tooltip className="mx-1" title="Editar Punto Venta" aria-label="editar-ptoVenta">
                                      <a className="icon-container-actions p-0 mx-1 d-flex">
                                        <div style={{backgroundColor: Colors.DARK_GRAY}}/>
                                        <i style={{color: Colors.DARK_GRAY}} className="fas fa-pen fa-2x"/>
                                      </a>
                                    </Tooltip>
                                }

                                <div className="p-2" style={{fontSize: '1rem', fontWeight: 'bold', color: Colors.DARK_GRAY}}>Editar</div>
                              </div>


                              <div className="mt-2">
                                <div className="w-100 text-overflow-card-punto-venta-oneline text-right" style={{lineHeight: 1.3}}> <span className="font-weight-bold mr-1">Fecha Creación:</span> {isEmpty(item.dtIngreso) ? "XXXXXXX" : item.dtIngreso}</div>
                                <div className="w-100 text-overflow-card-punto-venta-oneline text-right" style={{lineHeight: 1.3}}> <span className="font-weight-bold mr-1">Ult. modificación:</span> {isEmpty(item.dtUsrAuditoria) ? "XXXXXXX" : item.dtUsrAuditoria}</div>
                              </div>


                          </div>
                      </div>
                      <hr className="mx-2" style={{borderColor: Colors.GRAY_LOW}}/>
                      <div className="my-2 mx-2 d-flex justify-content-between">
                        <div className="d-flex align-items-center">
                          <div className="px-2" style={{fontSize: '0.9rem'}}>Criterios comerciales: <span style={{fontWeight: 'bold', fontSize: '1rem'}}>{isEmpty(item?.jsPuntoVentas) ? `0` : item?.jsPuntoVentas?.length}</span></div>
                          <div className="form-check mx-2">
                              <CheckBox identificador="checkActivos"
                                        label={`Activos: ${getItemsState(item?.jsPuntoVentas, true, 'estado')}`}
                                        onChange={({name, checked}) => handleChangeFilter({name, checked})}/>
                          </div>
                          <div className="form-check mx-2">
                              <CheckBox identificador="checkInactivos"
                                      label={`Inactivos: ${getItemsState(item?.jsPuntoVentas, false, 'estado')}`}
                                      onChange={({name, checked}) => handleChangeFilter({name, checked})}/>
                          </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-end ">

                          {
                            isEditing ?
                              <button onClick={() => handleCreateNewRutaPtoVenta()} className="btn btn-primary text-center px-2 mx-1 py-1 align-self-center" style={{
                                height: 35, backgroundColor: Colors.GREEN_SWITCH_ACTIVE, borderColor: Colors.GREEN_SWITCH_ACTIVE
                              }}><i className="fas fa-plus Mx-2"/> {` Añadir Ruta`}</button>
                              :
                              <button className="btn btn-primary text-center px-2 mx-1 py-1 align-self-center" style={{
                                height: 35, backgroundColor: Colors.DARK_GRAY, borderColor: Colors.DARK_GRAY
                              }}><i className="fas fa-plus Mx-2"/> {` Añadir Ruta`}</button>
                          }


                          {
                            item?.jsPuntoVentas?.length > 0 &&
                            <Tooltip title="Ver Rutas" aria-label="ver-rutas">
                              <a  data-toggle="collapse" data-target={`#collapseRutas${item.idPtoVenta}`} aria-expanded="false" aria-controls={`#collapseRutas${item.idPtoVenta}`}
                                  className="icon-container-actions p-0 mx-1 d-flex">
                                <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
                                <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-chevron-down fa-2x"/>
                              </a>
                            </Tooltip>
                          }
                        </div>
                      </div>
                  </div>
              </div>
          </div>
          <div className="container mx-0 px-0 w-100 mw-100 collapse" id={`collapseRutas${item.idPtoVenta}`}>
            <div className="row mx-0 px-0 mb-4 position-relative">
              {
                item?.jsPuntoVentas?.map((itemPtoVenta) => {

                  return <div key={`keyPtoVentaItem${itemPtoVenta.idRuta}`}>
                    {
                      !stateFilterCriterioPtoVenta?.checkInactivos && !stateFilterCriterioPtoVenta?.checkActivos &&
                      <CardPuntoVentaRutas key={`cardPtoVentaItem${itemPtoVenta.idRuta}`} item={itemPtoVenta}
                                           idPtoVenta={item.idPtoVenta}
                                           infoCli={infoCli} codTercero={infoCli?.idTercero}
                                           onChangePuntoVentaItem={({newState, item, idPtoVenta}) => Emitter.emit(ConstantEventEmitter.keyActionsUpdatePuntoVentaItem, {
                                             newState,
                                             item,
                                             idPtoVenta
                                           })} isEditing={isEditing}/>
                    }
                    {
                      stateFilterCriterioPtoVenta?.checkActivos && validStateChecked(itemPtoVenta?.estado) &&
                      <CardPuntoVentaRutas key={`cardPtoVentaItem${itemPtoVenta.idRuta}`} item={itemPtoVenta}
                                           idPtoVenta={item.idPtoVenta}
                                           infoCli={infoCli} codTercero={infoCli?.idTercero}
                                           onChangePuntoVentaItem={({newState, item, idPtoVenta}) => Emitter.emit(ConstantEventEmitter.keyActionsUpdatePuntoVentaItem, {
                                             newState,
                                             item,
                                             idPtoVenta
                                           })} isEditing={isEditing}/>
                    }
                    {
                      stateFilterCriterioPtoVenta?.checkInactivos && !validStateChecked(itemPtoVenta?.estado) &&
                      <CardPuntoVentaRutas key={`cardPtoVentaItem${itemPtoVenta.idRuta}`} item={itemPtoVenta}
                                           idPtoVenta={item.idPtoVenta}
                                           infoCli={infoCli} codTercero={infoCli?.idTercero}
                                           onChangePuntoVentaItem={({newState, item, idPtoVenta}) => Emitter.emit(ConstantEventEmitter.keyActionsUpdatePuntoVentaItem, {
                                             newState,
                                             item,
                                             idPtoVenta
                                           })} isEditing={isEditing}/>
                    }
                    </div>
                })
              }
            </div>
          </div>
        </>
    )
}

const CardPuntoVentaRutas = ({item: itemList, codTercero, onChangePuntoVentaItem, idPtoVenta, infoCli, isEditing}) => {

    const dispatch = useDispatch();
    const authState = useSelector( state => state.auth )
    const { idUsuario } = authState;
    const [ item, setItem ] = useState(itemList);

    const handleChangeSwitchState = (name, checked) => {

      alertQuestionService.showAlert({title: `Cambio de estado #${item.idRuta}`, question: `¿Estás seguro de cambiar el estado del registro?`,
        message: `Recuerda que al cambiar el estado del registro afectara las gestiones que asocien el registro seleccionado`,
        actionBtnAceptar: () => {

          clientesService.setStateRutaById({usrAuditoria: idUsuario, estado: checked ? 1 : 0, id: item.idRuta}).then(
            response => {
              const {status, msg, data} = response;

              if (status) {

                let itemCopy = Object.assign({}, item);

                itemCopy.estado = checked ? 1 : 0;

                setItem(itemCopy);

                dispatch({type: 'setStateAlert', alert: {type: GlobalConstants.alertSuccess, message: msg}});

                alertQuestionService.clear();

              } else {
                dispatch({type: 'setStateAlert', alert: {type: GlobalConstants.alertError, message: msg}});
              }
            },
            error => {
              dispatch({type: 'setStateAlert', alert: {type: GlobalConstants.alertError, message: error.toString()}});
            }
          );

        },
        actionBtnCancelar: () => alertQuestionService.clear(),
        type: GlobalConstants.alertInfo
    });


  }

    const handleEditRuta = () => {

        clientesService.getRutasById( item.idRuta ).then(
            response => {
                const {status, msg, data} = response;

                if (status) {

                    modalCRUDService.showModal({
                        props: {data: data, codTercero, idPuntoVenta: idPtoVenta, infoCli, function: ({newState, item, idPtoVenta}) => onChangePuntoVentaItem({newState, item, idPtoVenta})},
                        type: ConstantsFormCrud.modalCRUDClientesRutas,
                        title: `Ruta #${item.idRuta}`,
                        isAddMode: false,
                        isEditable: true,
                        dense: true,
                        id: `modalCreateEditRutas`,
                        size: `xl`});


                } else {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
                }
            },
            error => {
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });
            }
        );

    }

    return(
        <div className="col-12 p-2">
            <div className="cardPtoVentaRuta" style={{backgroundColor: validStateChecked(item.estado) ? 'white' : Colors.GRAY_LOW}}>

                <div className="d-flex align-items-center justify-content-between">

                  <div className="container" style={{flex: 1}}>

                    <div className="row align-items-center my-1 mx-0">

                      <div className="col-xs-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 d-flex align-items-center">
                        <div className="px-1  font-weight-bold" style={{fontSize: "1.2rem", color: Colors.RED_SWITCH_INACTIVE}}>{isEmpty(item.empresa) ? "XXXXXXXXXXXXXXX" : item.empresa}</div>
                      </div>

                      <div className="col-xs-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 d-flex align-items-center">
                        <div className="font-weight-bold px-1">Tipologia: </div>
                        <div className="px-1 text-overflow">{`${isEmpty(item.idTipologia) ? "XXXX" : convertToString(item.idTipologia)} - ${isEmpty(item.txTipologia) ? "XXXXXXXXXX" : convertToString(item.txTipologia).toUpperCase()}`}</div>
                      </div>

                      <div className="col-xs-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 d-flex align-items-center">
                        <div className="font-weight-bold px-1">Canal: </div>
                        <div className="px-1 text-overflow">{`${isEmpty(item.nbCanal) ? "XXXX" : convertToString(item.nbCanal)} - ${isEmpty(item.txCanal) ? "XXXXXXXXXX" : convertToString(item.txCanal).toUpperCase()}`}</div>
                      </div>

                      <div className="col-xs-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 d-flex align-items-center">
                        <div className="font-weight-bold px-1">SCanal: </div>
                        <div className="px-1 text-overflow">{`${isEmpty(item.nbSubCanal) ? "XXXX" : convertToString(item.nbSubCanal)} - ${isEmpty(item.txsubCanal) ? "XXXXXXXXXX" : convertToString(item.txsubCanal).toUpperCase()}`}</div>
                      </div>

                      <div className="col-xs-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 d-flex align-items-center">
                        <div className="font-weight-bold px-1">ERP: </div>
                        <div className="px-1 text-overflow">{isEmpty(item.idErp) ? "XXXXXX" : item.idErp}</div>
                      </div>

                      <div className="col-xs-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 d-flex align-items-center">
                        <div className="font-weight-bold px-1">Portafolio: </div>
                        <div className="px-1 text-overflow">{`${isEmpty(item.idPortafolio) ? "XXXX" : convertToString(item.idPortafolio)} - ${isEmpty(item.txPortafolio) ? "XXXXXXXXXX" : convertToString(item.txPortafolio).toUpperCase()}`}</div>
                      </div>

                      <div className="col-xs-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 d-flex align-items-center">
                        <div className="font-weight-bold px-1">Zona: </div>
                        <div className="px-1 text-overflow">{isEmpty(item.idZona) ? "XXXXX" : item.idZona}</div>
                      </div>

                      <div className="col-xs-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 d-flex align-items-center">
                        <div className="font-weight-bold px-1">Asesor: </div>
                        <div className="px-1 text-overflow">{isEmpty(item.vendedor) ? "XXXXX-XXXXX" : item.vendedor}</div>
                      </div>

                      <div className="col-xs-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 d-flex align-items-center">
                        <div className="font-weight-bold px-1">Propietario: </div>
                        <div className="px-1 text-overflow">{isEmpty(item.propietario) ? "XXXXX" : item.propietario}</div>
                      </div>


                    </div>

                  </div>

                  <div className="py-2 px-2">

                    <div className="d-flex align-items-center justify-content-center">
                      <div className="mr-2 d-flex align-items-center">
                        <div className="circulo-indicador-visita"/>
                        <div className="ml-1" style={{fontSize: "1rem"}}>Visita</div>
                      </div>
                      <div className="ml-2 d-flex align-items-center">
                        <div className="circulo-indicador-entrega"/>
                        <div className="ml-1" style={{fontSize: "1rem"}}>Entrega</div>
                      </div>
                    </div>

                    <DiasVisitaEntregaView diasOrdenVisita={getDiasVisitaEntregaVector(item.diasVisita, item.ordenVisita)}
                                           diasOrdenEntrega={getDiasVisitaEntregaVector(item.diasEntrega, item.ordenEntrega)}/>

                  </div>

                    <div className="py-2 px-3">
                        <CustomSwitch disabled={!isEditing} name="estado" state={item.estado} handleChange={(name, checked) => handleChangeSwitchState(name, checked)}/>
                        <div className="d-flex align-items-center justify-content-center mt-2">
                          {
                            isEditing ?
                              <Tooltip title="Editar Ruta" aria-label="editar-ruta">
                                <a onClick={() => handleEditRuta()}
                                   className="icon-container-actions p-0 m-0 d-flex">
                                  <div style={{backgroundColor: Colors.COLOR_BLUE_THEME}}/>
                                  <i style={{color: Colors.COLOR_BLUE_THEME}} className="fas fa-pen fa-2x"/>
                                </a>
                              </Tooltip>
                              :
                              <Tooltip title="Editar Ruta" aria-label="editar-ruta">
                                <a className="icon-container-actions p-0 m-0 d-flex">
                                  <div style={{backgroundColor: Colors.DARK_GRAY}}/>
                                  <i style={{color: Colors.DARK_GRAY}} className="fas fa-pen fa-2x"/>
                                </a>
                              </Tooltip>
                          }

                        </div>
                    </div>

                </div>



            </div>
        </div>
    )

}

const PuntosVenta = ({isEditing, properties, stateSelects}) => {

    const { codTercero, infoPtoVentas, params, infoCli: infoCliTemp } = properties;
    const [ infoCli, setInfoCli ] = useState(infoCliTemp);
    const [ statePuntosVenta, setStatePuntosVenta ] = useState(infoPtoVentas);


    const handleEditPuntoVenta = ({newState, item}) => {

        let data = statePuntosVenta.slice();

        data.forEach((element) => {

            if(convertToString(element?.idPtoVenta) === convertToString(item?.idPtoVenta)){

                element.cantidadRutas = newState.cantidadRutas;
                element.celular = newState.celular;
                element.direccion = newState.direccion;
                element.dtUsrAuditoria = newState.dtUsrAuditoria;
                element.estado = newState.estado;
                element.idCiudad = newState.idCiudad;
                element.idCliente = newState.idCliente;
                element.idErp = newState.idErp;
                element.idPtoVenta = newState.idPtoVenta;
                element.idUsrAuditoria = newState.idUsrAuditoria;
                element.telefono = newState.telefono;
                element.txCiudad = newState.txCiudad;
                element.txNegocio = newState.txNegocio;
                element.nmDepartamento = newState.nmDepartamento;
                element.txBarrio = newState.txBarrio;
                element.dtIngreso = newState.dtIngreso;

                return false;
            }
        })

        setStatePuntosVenta(data);
    }

    const handleAddPuntoVenta = ({newState}) => {

        let data = statePuntosVenta.slice();

        data.push({
            cantidadRutas: newState.cantidadRutas,
            celular: newState.celular,
            direccion: newState.direccion,
            dtUsrAuditoria: newState.dtUsrAuditoria,
            estado: newState.estado,
            idCiudad: newState.idCiudad,
            idCliente: newState.idCliente,
            idErp: newState.idErp,
            idPtoVenta: newState.idPtoVenta,
            idUsrAuditoria: newState.idUsrAuditoria,
            telefono: newState.telefono,
            txCiudad: newState.txCiudad,
            txNegocio: newState.txNegocio,
            nmDepartamento: newState.nmDepartamento,
            txBarrio: newState.txBarrio,
            dtIngreso: newState.dtIngreso,
        });

        setStatePuntosVenta(data);
    }

    const handleCreateNewPuntoVenta = () => {

        modalCRUDService.showModal({
            props: {codTercero: infoCli?.idTercero, data: {}, infoCli: infoCli, function: ({newState}) => handleAddPuntoVenta({newState})},
            type: ConstantsFormCrud.modalCRUDClientesPuntoVentaCRUD,
            title: `Crear Punto Venta Cliente #${infoCli?.idTercero}`,
            isAddMode: true,
            isEditable: true,
            dense: true,
            id: `modalPuntoVenta`,
            size: `xl`});

    }

    const handleAddPuntoVentaItem = ({newState, idPtoVenta}) => {

        let data = statePuntosVenta.slice();

        if(isArray(data)){

            for(let item of data){

                if(convertToString(item.idPtoVenta) === convertToString(idPtoVenta)){

                    let { jsPuntoVentas } = item;

                    if(isArray(jsPuntoVentas)) {

                        jsPuntoVentas.push({
                            diasEntrega : newState.diasEntrega,
                            diasVisita : newState.diasVisita,
                            empresa : newState.txEmpresa,
                            estado : newState.idEstado,
                            idEmpresa : newState.idEmpresa,
                            idErp : newState.idERP,
                            idRuta : newState.idPuntoVentaItem,
                            idZona : newState.idZona,
                            ordenEntrega : newState.ordenEntrega,
                            ordenVisita : newState.ordenVisita,
                            vendedor : newState.txZona,
                            idPortafolio : newState.idPortafolio,
                            txPortafolio : newState.txPortafolio,
                            nbCanal : newState.nbCanal,
                            txCanal : newState.txCanal,
                            nbSubCanal : newState.nbSubCanal,
                            txsubCanal : newState.txsubCanal,
                            idTipologia : newState.idTipologia,
                            txTipologia : newState.txTipologia
                        });

                    }

                    break;

                }

            }

        }


        setStatePuntosVenta(data);
    }

    const handleEditPuntoVentaItem = ({newState, item, idPtoVenta}) => {

        let data = statePuntosVenta.slice();

        if(isArray(data)){

            for(let itemData of data){

                if(convertToString(itemData.idPtoVenta) === convertToString(idPtoVenta)){

                    let { jsPuntoVentas } = itemData;

                        for(let itemJsPuntoVenta of jsPuntoVentas){

                            if(convertToString(itemJsPuntoVenta?.idRuta) === convertToString(item?.idPuntoVentaItem)){

                                    itemJsPuntoVenta.diasEntrega = newState.diasEntrega;
                                    itemJsPuntoVenta.diasVisita = newState.diasVisita;
                                    itemJsPuntoVenta.empresa = newState.txEmpresa;
                                    itemJsPuntoVenta.estado = newState.idEstado;
                                    itemJsPuntoVenta.idEmpresa = newState.idEmpresa;
                                    itemJsPuntoVenta.idErp = newState.idERP;
                                    itemJsPuntoVenta.idRuta = newState.idPuntoVentaItem;
                                    itemJsPuntoVenta.idZona = newState.idZona;
                                    itemJsPuntoVenta.ordenEntrega = newState.ordenEntrega;
                                    itemJsPuntoVenta.ordenVisita = newState.ordenVisita;
                                    itemJsPuntoVenta.vendedor = newState.txZona;
                                    itemJsPuntoVenta.idPortafolio = newState.idPortafolio;
                                    itemJsPuntoVenta.txPortafolio = newState.txPortafolio;
                                    itemJsPuntoVenta.nbCanal = newState.nbCanal;
                                    itemJsPuntoVenta.txCanal = newState.txCanal;
                                    itemJsPuntoVenta.nbSubCanal = newState.nbSubCanal;
                                    itemJsPuntoVenta.txsubCanal = newState.txsubCanal;
                                    itemJsPuntoVenta.idTipologia = newState.idTipologia;
                                    itemJsPuntoVenta.txTipologia = newState.txTipologia;



                                    break;

                            }

                        }

                    break;

                }

            }

        }


        setStatePuntosVenta(data);
    }


    useEffect(() => {
      return () => {
        Emitter.off(ConstantEventEmitter.keyActionsUpdateHeaderInfoCliente);
        Emitter.off(ConstantEventEmitter.keyActionsUpdatePuntoVentaItem);
      }
    },[])

    useEffect(() => {
        Emitter.on(ConstantEventEmitter.keyActionsUpdateHeaderInfoCliente, ({infoCli}) => setInfoCli(infoCli));
        Emitter.on(ConstantEventEmitter.keyActionsUpdatePuntoVentaItem, ({newState, item, idPtoVenta}) => handleEditPuntoVentaItem({newState, item, idPtoVenta}));
    }, [])

    return (
        <>
            <div className="d-flex justify-content-between align-items-center px-0">

                <HeaderClientInformation infoCli={infoCli}/>

                <div className="px-3 py-1 d-flex flex-column justify-content-between">
                    <div><p className="py-1 m-0 font-weight-bold text-right" style={{fontSize: "1em"}}>{statePuntosVenta?.length} Puntos Venta</p></div>
                    <div>
                      {
                        Object.keys(infoCli)?.length > 0 && isEditing ?
                          <button onClick={() => handleCreateNewPuntoVenta()} className="btn btn-primary text-center px-2 py-1" style={{height: 35, backgroundColor: Colors.RED_SWITCH_INACTIVE, borderColor: Colors.RED_SWITCH_INACTIVE}}><i className="fas fa-plus mx-2"/> {` Añadir Punto Venta`}</button>
                          :
                          <button className="btn btn-primary text-center px-2 py-1" style={{height: 35, backgroundColor: Colors.DARK_GRAY, borderColor: Colors.DARK_GRAY}}><i className="fas fa-plus Mx-2"/> {` Añadir Punto Venta`}</button>
                      }
                    </div>
                </div>
            </div>


            <div className="mx-2 mt-2 mb-2 text-center text-muted content-divider divider-form">
                <span/>
            </div>

            <div className="mt-4">
            {
                statePuntosVenta.map((item) => (
                    <div key={`cardPtoVenta${item.idPtoVenta}`}>

                        <CardsPuntoVenta item={item} infoCli={infoCli} codTercero={infoCli?.idTercero}
                                         onChangePuntoVenta={({newState, item}) => handleEditPuntoVenta({newState, item})}
                                         onAddPuntoVentaItem={({newState, idPtoVenta}) => handleAddPuntoVentaItem({newState, idPtoVenta})}
                                         isEditing={isEditing}/>

                    </div>
                ))
            }
            </div>
        </>
    )

}

const ExisteDocumento = () => {

    const dispatch = useDispatch();
    const { control } = useFormContext();

    const valueDocumento = useWatch({
      control,
      name: "documento"
    })

    useEffect(() => {

      if(valueDocumento?.length >= 7){

        clientesService.getClientByDocumento( valueDocumento ).then(
          response => {
            const {status, msg, data} = response;

            if (status) {

              if(data?.idTercero){

                    alertQuestionService.showAlert({title: `Existe el usuario #${valueDocumento}`, question: `¿Desea buscar el documento #${valueDocumento}?`,
                      message: `Al aceptar se buscara el usuario existente para editarlo y/o agregar puntos de venta,
                       al cancelar se cerrara el cuadro de dialogo y perdera la información recolectada, recuerda que no puedes crear mas de un usuario con el mismo documento`,
                      actionBtnAceptar: () => {

                        clientesService.getClientById(data?.idTercero).then(
                          response => {
                            const {status, msg, data} = response;

                            if (status) {

                              modalCRUDService.clear();

                              modalCRUDService.showModal({
                                props: {
                                  codTercero: data?.infoCli?.idTercero,
                                  infoCli: data.infoCli,
                                  infoPtoVentas: data.infoPtoVentas
                                },
                                type: ConstantsFormCrud.modalCRUDClientes,
                                title: `Editar Cliente #${data?.infoCli?.idTercero}`,
                                isAddMode: false,
                                isEditable: true,
                                dense: true,
                                id: modalCRUDService.defaultId,
                                size: `xl`
                              });

                              alertQuestionService.clear();

                            } else {
                              dispatch({
                                type: 'setStateAlert',
                                alert: {type: GlobalConstants.alertError, message: msg}
                              });
                            }

                          },
                          error => {
                            dispatch({
                              type: 'setStateAlert',
                              alert: {type: GlobalConstants.alertError, message: error.toString()}
                            });
                          }
                        );

                      },
                      actionBtnCancelar: () => {
                      modalCRUDService.clear();
                      alertQuestionService.clear();
                      },
                      close: false
              });
              }

            } else {
              dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
            }

          },
          error => {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });
          }
        );

      }

    }, [valueDocumento])

    return (
      <></>
    )

}

const TypeDocument = ({isEditing, isAddMode, stateSelects}) => {

  const { handleSubmit, setValue, control, formState: { errors } } = useFormContext();

  const tipeDocumento = useWatch({
    control,
    name: "tipoDocumento"
  })

  const ref = useRef(tipeDocumento);

  useEffect(() => {
    if(convertToString(tipeDocumento) !== convertToString(ref.current)){
      setValue("documento", "");
    }
  }, [tipeDocumento])

  return (
    <>

      <SelectForm inputProps={{control}} disabled={!isAddMode} identificador="tipoDocumento" label="Tipo Documento"
                  options={stateSelects?.arrTipoDocumentos}  required={true} className={`${classResponsiveForm}`}
                  customError={errors.tipoDocumento ? ERRORFIELDREQUIRED : null} />

      <InputForm inputProps={{control}} disabled={!isAddMode} identificador="documento" label="Nro. Documento"
                 placeholder="Ej: 1098000000" type={convertToString(tipeDocumento) !== "C.E." ? "number" : "text"} required={true} className={`${classResponsiveForm}`}
                 customError={errors.documento ? "Longitud min 3 y max 13" : null} rules={{ minLength: 3, maxLength: 13}} />

    </>
  )

}

const RazonSocialByNaturalezaJuridica = ({isEditing}) => {

  const { handleSubmit, setValue, control, formState: { errors } } = useFormContext();

  const values = useWatch({
    control,
    name: ["naturalezaJuridica", "nombre1", "nombre2", "apellido1", "apellido2"]
  })

  useEffect(() => {

    if(values[0] === "N"){
      setValue("razonSocial", validarEspaciosEnBlanco(
        `${values[1] ? values[1] : ""} ${values[2] ? values[2] : ""} ${values[3] ? values[3] : ""} ${values[4] ? values[4] : ""}`
      ))
    }
    else{
        setValue("nombre1", "")
        setValue("nombre2", "")
        setValue("apellido1", "")
        setValue("apellido2", "")
    }

  }, [values[0]])

  useEffect(() => {

    // setValue("razonSocial", validarEspaciosEnBlanco(
    //   `${values[1] ? values[1] : ""} ${values[2] ? values[2] : ""} ${values[3] ? values[3] : ""} ${values[4] ? values[4] : ""}`
    // ))
    if(values[0] === "N"){
      setValue("razonSocial", validarEspaciosEnBlanco(
        `${values[1] ? values[1] : ""} ${values[2] ? values[2] : ""} ${values[3] ? values[3] : ""} ${values[4] ? values[4] : ""}`
      ))
    }

  }, [values[1], values[2], values[3], values[4]])

  return(
    <>

      <InputForm inputProps={{control}} readOnly={values[0] === "N"} disabled={!isEditing} identificador="razonSocial"
                 label="Razón Social" placeholder="Ej: Tienda Peréz" type="text" className={classResponsiveFormDoubleWidth}
                 required={true} customError={errors.razonSocial ? ERRORFIELDREQUIRED : null}/>

      <InputForm inputProps={{control}} readOnly={values[0] !== "N"} disabled={!isEditing}  identificador="nombre1"
                 label="Primer Nombre" placeholder="Ej: Carlos" type="text" className={classResponsiveForm}
                 required={values[0] === "N"} customError={errors.nombre1 ? "Longitud max 30" : null} rules={{ maxLength: 30}}/>

      <InputForm inputProps={{control}} readOnly={values[0] !== "N"} disabled={!isEditing} identificador="nombre2"
                 label="Segundo Nombre" placeholder="Ej: Andres" type="text" className={classResponsiveForm}
                 required={false} customError={errors.nombre2 ? "Longitud max 30" : null} rules={{ maxLength: 30}}/>


      <InputForm inputProps={{control}} readOnly={values[0] !== "N"} disabled={!isEditing} identificador="apellido1"
                 label="Primer Apellido" placeholder="Ej: Peréz" type="text" className={classResponsiveForm}
                 required={values[0] === "N"} customError={errors.apellido1 ? "Longitud max 30" : null} rules={{ maxLength: 30}}/>


      <InputForm inputProps={{control}} readOnly={values[0] !== "N"} disabled={!isEditing} identificador="apellido2"
                 label="Segundo Apellido" placeholder="Ej: Gaviria" type="text" className={classResponsiveForm}
                 required={false} customError={errors.apellido2 ? "Longitud max 30" : null} rules={{ maxLength: 30}}/>

    </>
  )

}

const DatosBasicos = ({ isAddMode, isEditing, properties, stateSelects }) => {

    const { codTercero, params, tableRef } = properties;
    const dispatch = useDispatch();
    const { handleSubmit, control, formState: { errors } } = useFormContext();

    const onSuccessSubmit = data => {

        data['idCliente'] = isAddMode && isEditing ? null : isEditing ? codTercero : 'LOCK';
        data['ac'] = isAddMode && isEditing ? 'C' : isEditing ? 'A' : 'LOCK';

        data.idCiudad = isObject(data?.idCiudad) ? data.idCiudad.id : data.idCiudad;
        data.idDepartamento = isObject(data?.idDepartamento) ? data.idDepartamento.id : data.idDepartamento;
        data.idPais = isObject(data?.idPais) ? data.idPais.id : data.idPais;

        clientesService.setCrudClientes(data).then(
            response => {

                const {status, msg, data: datos, sync} = response;

                if (status) {
                    if(datos?.idmsg === 200){

                        if(isAddMode && isEditing){

                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: msg } });

                            Emitter.emit(ConstantEventEmitter.keyActionsUpdateHeaderInfoCliente, {infoCli: sync});

                            Emitter.emit(ConstantEventEmitter.eventChangeTab, "puntosVenta");


                            tableRef.current.api.applyTransaction({
                              add: [{
                                id: datos?.idreg,
                                estado: data.estadoCli,
                                cliente: isEmpty(data.razonSocial) ? validarEspaciosEnBlanco(`${data.nombre1} ${data.nombre2} ${data.apellido1} ${data.apellido2}`) : data.razonSocial,
                                documento: data.documento,
                                direccion: data.direccion,
                                ciudad: data.idCiudad,
                                telFijo: data.telFijo
                              }]
                            })


                        }
                        else{

                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: msg } });

                            Emitter.emit(ConstantEventEmitter.keyActionsUpdateHeaderInfoCliente, {infoCli: sync});

                            Emitter.emit(ConstantEventEmitter.eventChangeTab, "puntosVenta");

                            const rowNode = params.api.getRowNode(params.node.id);

                            rowNode.setDataValue("estado", data?.estadoCli);
                            rowNode.setDataValue("cliente", isEmpty(data.razonSocial) ? validarEspaciosEnBlanco(`${data.nombre1} ${data.nombre2} ${data.apellido1} ${data.apellido2}`) : data.razonSocial);
                            rowNode.setDataValue("documento", data?.documento);
                            rowNode.setDataValue("direccion", data?.direccion);
                            rowNode.setDataValue("ciudad", data?.idCiudad);
                            rowNode.setDataValue("telFijo", data?.telFijo);

                        }

                    }
                    else{

                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: datos?.txmsg } });

                    }

                } else {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
                }


            },
            error => {
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });
            }
        );

    }

    const onErrorSubmit = errors => {
        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Faltan campos obligatorios, por favor válida la información' } });
    }

    return(
            <div className="container mx-0 px-0 w-100 mw-100">


            <div className="d-flex justify-content-end align-items-center px-0 pb-3">
                { isEditing &&
                <Tooltip title="Guardar" aria-label="guardar">
                    <a onClick={handleSubmit(onSuccessSubmit, onErrorSubmit)}
                       className="icon-container-actions d-flex">
                        <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                        <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-check fa-2x"/>
                    </a>
                </Tooltip>
                }
                <Tooltip title="Cancelar" aria-label="cancelar">
                    <a onClick={() => {modalCRUDService.clear()}} className="icon-container-actions d-flex">
                        <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
                        <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times fa-2x"/>
                    </a>
                </Tooltip>
            </div>


            <div className="d-flex justify-content-between align-items-center">
                <CalendarForm inputProps={{control}} disabled={true} identificador="dtIngreso"  label="Fecha Ingreso"
                              required={true} className={`${classResponsiveForm}`} customError={errors.dtIngreso ? ERRORFIELDREQUIRED : null} />
                <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="estadoCli" options={optionsEstados} required={true}
                                 defaultValue="1" label="Estado" className={`${classResponsiveFormWithoutPaddingX}`} customError={errors.estadoCli ? ERRORFIELDREQUIRED : null}/>
            </div>

            <div className="mx-2 text-center text-muted content-divider divider-form mb-3">
                <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Identificación</span>
            </div>

            <div className="row mx-0 px-0">

                <TypeDocument isEditing={isEditing} isAddMode={isAddMode} stateSelects={stateSelects} />

                { isAddMode &&
                  <ExisteDocumento/>
                }

                <NestedInputForm disabled={!isEditing} keyFatherValue="documento" keyIdentificador="digitoVerificacion"
                                 label="Dig. Verificación" placeHolder="Ej: 6" type="number" readOnly={true} className={classResponsiveForm}
                                 required={true} customError={errors.digitoVerificacion ? ERRORFIELDREQUIRED : null} executeFunction={getDigitoVerificacion}/>

                <SelectForm inputProps={{control}} disabled={!isEditing} identificador="naturalezaJuridica" label="Naturaleza Juridica"
                            options={stateSelects?.arrNaturalezasJuridicas} required={true} className={`${classResponsiveForm}`}
                            customError={errors.naturalezaJuridica ? ERRORFIELDREQUIRED : null} />

                <RazonSocialByNaturalezaJuridica isEditing={isEditing}/>

                <SelectForm inputProps={{control}} disabled={!isEditing} identificador="estadoCivil" label="Estado Civil"
                          options={stateSelects?.arrEstadosCiviles}  required={false} className={`${classResponsiveForm}`}
                          customError={errors.estadoCivil ? ERRORFIELDREQUIRED : null} />


            </div>


            <div className="mx-2 text-center text-muted content-divider divider-form my-3">
                <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Responsabilidades</span>
            </div>
            <div className="row mx-0 px-0">

                <SelectForm inputProps={{control}} disabled={!isEditing} identificador="respFiscal" label="Resp. Fiscales"
                            options={stateSelects?.arrRespFiscales}  required={true} className={`${classResponsiveFormWidthHeader}`}
                            customError={errors.respFiscal ? ERRORFIELDREQUIRED : null} />

                <SelectForm inputProps={{control}} disabled={!isEditing} identificador="regFiscal" label="Resp. IVA"
                            options={stateSelects?.arrRegFiscales} required={true} className={`${classResponsiveFormWidthHeader}`}
                            customError={errors.regFiscal ? ERRORFIELDREQUIRED : null} />

                <SelectForm inputProps={{control}} disabled={!isEditing} identificador="respIva" label="Resp. Tributarias"
                            options={stateSelects?.arrRespIVA}  required={true} className={`${classResponsiveFormWidthHeader}`}
                            customError={errors.respIva ? ERRORFIELDREQUIRED : null} />

            </div>

            <div className="mx-2 text-center text-muted content-divider divider-form my-3">
                <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Datos de contacto</span>
            </div>
            <div className="row mx-0 px-0">

                <InputForm inputProps={{control}} disabled={!isEditing} identificador="telFijo" label="Teléfono"
                           placeholder="Ej: 6787621" type="number" required={false} className={`${classResponsiveFormWidthHeader}`}
                           customError={errors.telFijo ? "Longitud min 7 y max 11" : null} rules={{ minLength: 7, maxLength: 11}} />

                <InputForm inputProps={{control}} disabled={!isEditing} identificador="celular" label="Celular"
                           placeholder="Ej: 3002467589" type="number" required={false} className={`${classResponsiveFormWidthHeader}`}
                           customError={errors.celular ? "Longitud min 10 y max 11" : null} rules={{ minLength: 10, maxLength: 11}}/>

                <InputForm inputProps={{control}} disabled={!isEditing} identificador="correo" label="Correo Electrónico"
                           placeholder="Ej: amovil@amovil.co" type="text" required={false} className={`${classResponsiveFormWidthHeader}`}
                           rules={{pattern: { value: /\S+@\S+\.\S+/}}} customError={errors.correo ? ERROREMAILFIELDREQUIRED : null}/>

                <InputForm inputProps={{control}} disabled={!isEditing} identificador="correoRecepcionDE" label="Correo de facturación electrónica"
                           placeholder="Ej: amovil@amovil.co" type="text" required={false} className={`${classResponsiveFormWidthHeader}`}
                           rules={{pattern: { value: /\S+@\S+\.\S+/}}} customError={errors.correoRecepcionDE ? ERROREMAILFIELDREQUIRED : null}/>


            </div>

            <div className="mx-2 text-center text-muted content-divider divider-form my-3">
                <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Información Localización</span>
            </div>

            <div className="row mx-0 px-0">

                <SelectFormVirtualize inputProps={{control}} isEditing={!isEditing} identificador="idPais" label="País" required={true}
                                      className={classResponsiveFormWidthHeader} options={stateSelects?.arrPaises}
                                      customError={errors.idPais ? ERRORFIELDREQUIRED : null}/>

                <NestedSelectVirtualizeForm isEditing={!isEditing} keyIdentificador="idDepartamento" label="Departamento" required={true}
                                      className={classResponsiveFormWidthHeader} options={stateSelects?.arrDepartamentos}
                                            customError={errors.idDepartamento ? ERRORFIELDREQUIRED : null}
                                            keyFatherValue="idPais"/>

                <NestedSelectVirtualizeForm isEditing={!isEditing} keyIdentificador="idCiudad" label="Ciudad" required={true}
                                            className={classResponsiveFormWidthHeader} options={stateSelects?.arrCiudades}
                                            customError={errors.idCiudad ? ERRORFIELDREQUIRED : null}
                                            keyFatherValue="idDepartamento"/>


                <InputForm inputProps={{control}} disabled={!isEditing} identificador="barrio" label="Barrio"
                           placeholder="Ej: Versalles" type="text" required={true} className={`${classResponsiveFormWidthHeader}`}
                           customError={errors.barrio ? "Longitud max 50" : null} rules={{ maxLength: 50}} />


            </div>

            <div className="row mx-0 px-0">

                <GeneradorDirecciones props={{control}} className={`${classResponsiveFormWidthHeader}`} identificador="direccion" required={true}
                                      label="Dirección" customError={errors.direccion ? ERRORFIELDREQUIRED : null}  />

            </div>


        </div>
    )

}

const Evidencias = ({isEditing, properties, stateSelects}) => {

  const { codTercero, infoPtoVentas, params, infoCli: infoCliTemp } = properties;
  const [ infoCli, setInfoCli ] = useState(infoCliTemp);

  const dispatch = useDispatch();
  const { register: registerEvidencias, setValue: setValueEvidencias, handleSubmit: handleSubmitEvidencias,
    reset: resetEvidencias, control: controlEvidencias, formState: { errors: errorsEvidencias } } = useForm({defaultValues: {}});

  const [stateAcceptedFiles,  setStateAcceptedFiles] = useState([]);

  const [stateImagenes, setStateImagenes] = useState({stateImages: [], stateImagesDelete: []});

  const { stateImages, stateImagesDelete } = stateImagenes;

  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    inputRef
  } = useDropzone({
    accept: 'image/jpeg, image/png',
    maxFiles: 6
  });

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isDragActive ? activeStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isDragActive,
    isDragReject,
    isDragAccept
  ]);

  const removeCurrentFile = item  => {
    setStateImagenes({ stateImages :stateImages?.filter(x => convertToString(x.idTipo) !== convertToString(item.idTipo)), stateImagesDelete: [...stateImagesDelete, item] });
  }

  const removeFile = file  => {
    acceptedFiles.splice(file, 1);
    setStateAcceptedFiles(acceptedFilesItem);
  }

  const acceptedFilesItem = () => {
    return acceptedFiles.map((file, index) => {
      return <li key={file.path}>
        <div className="d-flex flex-column align-items-center justify-content-center px-2">
          <div className="position-relative">
            <Zoom>
              <img className="borderImg" src={URL.createObjectURL(file)}
                   style={{width: 100, height: 100, borderRadius: 10, objectFit: 'cover'}}/>
            </Zoom>
            <div className="d-flex justify-content-end align-items-center px-0 pb-3 position-absolute" style={{top:-10, right: -10}}>
              <Tooltip title="Eliminar archivo" aria-label="eliminarArchivo">
                <a onClick={() => removeFile(index)}
                   className="icon-container-actions d-flex mr-0">
                  <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
                  <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times"/>
                </a>
              </Tooltip>
            </div>

          </div>

          <SelectFormVirtualize inputProps={{control: controlEvidencias}} disabled={!isEditing}
                                identificador={`file${index}`} label="Tipo Doc."
                                options={optionsTiposDocumento} required={true} className={`w150 mb-2 mt-3`}
                                customError={errorsEvidencias[file.path] ? ERRORFIELDREQUIRED : null} showId={false}/>
          {/*<p className="m-0 font-weight-bold">{file.size} bytes</p>*/}
        </div>
      </li>
    })
  }

  useEffect(() => {
    setStateAcceptedFiles(acceptedFilesItem);
  }, [acceptedFiles])

  const removeAll = () => {
    acceptedFiles.length = 0
    acceptedFiles.splice(0, acceptedFiles.length)
    inputRef.current.value = ''
    setStateAcceptedFiles(null);
  }

  const busqueda = (arr) => {
    return arr.reduce((acc, obj) => {
      acc[obj.id] = ++acc[obj.id] || 0;
      return acc;
    }, {})
  };

  const duplicados = (arr) => {
    return arr.filter((obj) => {
      return !isEmpty(obj.id) && busqueda(arr)[obj.id];
    })
  };


  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
      {
          errors?.length > 0 &&
          <li className="font-weight-bold" style={{color: Colors.RED_SWITCH_INACTIVE}} key={errors[0]?.code}>El tipo de archivo debe ser una imagen de tipo image/jpeg o image/png y no debe exceder 6 imagenes</li>
      }

    </li>
  ));

  const onSuccessSubmitEvidencias = data => {


    let currentImages = validArray(stateImages).slice();
    let arrAcceptedFiles = validArray(acceptedFiles).slice();

    if(arrAcceptedFiles.length === 0 && currentImages.length === 0){
      dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: "Debe seleccionar o arrastrar almenos una imagen para subir" } });
      return;
    }


    let arrImgSeleccionadas = Object.values(data);

    let existenDuplicados = validArray(duplicados(arrImgSeleccionadas)).slice();

    if(existenDuplicados.length > 0){
      let duplicadosList = existenDuplicados.map(x => x.text);
      dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: `Los documentos no se pueden subir dos veces, acontinuacion estos son los duplicados ${JSON.stringify(duplicadosList)}` } });
      return;
    }

    let imgExistentes = [];
    let imgAgregar = [];
    let i = 0;
    for(let item of arrAcceptedFiles){

      let tipoImgAceptada = data[`file${i}`];
      let existeEnLasImagenesActuales = currentImages.find(x => convertToString(x?.idTipo) === convertToString(tipoImgAceptada?.id));

      console.log(currentImages)
      console.log(existeEnLasImagenesActuales)

      if(existeEnLasImagenesActuales){
        imgExistentes.push(existeEnLasImagenesActuales.nmTipo);
      }
      else{

        imgAgregar.push({
          url: arrAcceptedFiles[i],
          idTipo: tipoImgAceptada?.id,
          nmTipo: tipoImgAceptada?.text
        })
      }

      i++;
    }


    if(imgExistentes.length > 0){
      dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: `Ya existen los siguientes documentos ${JSON.stringify(imgExistentes)}` } });
      return;
    }


    clientesService.crudEvidencias([...stateImages, ...imgAgregar], infoCli).then(
      response => {
        const {status, msg, data} = response;

        if (status) {

          removeAll();

          resetEvidencias({
            file1: "",
            file2: "",
            file3: "",
            file4: "",
            file5: "",
            file6: ""
          })

          setStateImagenes({stateImages: [...stateImages, ...imgAgregar] , stateImagesDelete: []})

          dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: msg } });

        } else {
          dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
        }


      },
      error => {
        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });
      }
    )


  }

  const onErrorSubmitEvidencias = error => {



  }

  useEffect(() => {

    let jsTercero = [];

    try{
      jsTercero = JSON.parse(infoCli?.jsTercero);
    }
    catch (e) { jsTercero = []; }

    let jsTerceroTemp = Object.assign({}, validObjectKeys(jsTercero));

    let jsArrDocumentos = validArray(jsTerceroTemp?.arrDocTerceros).slice();

    let arrImagenes = [];

    for(let item of jsArrDocumentos){

      let objValues = Object.values(item);
      arrImagenes = [...arrImagenes, ...objValues];

    }

    setStateImagenes({stateImages: validArray(arrImagenes).slice(), stateImagesDelete: []})

  }, [])

  return(

    <div>

      <div className="d-flex justify-content-between align-items-end px-0 mb-3">

        <HeaderClientInformation infoCli={infoCli}/>

        <div className="py-1 d-flex flex-column justify-content-between">
          <div>
            {
                Object.keys(infoCli)?.length > 0 && isEditing ?
                <button onClick={handleSubmitEvidencias(onSuccessSubmitEvidencias, onErrorSubmitEvidencias)} className="btn btn-primary text-center px-2 py-1" style={{height: 35, backgroundColor: Colors.GREEN_SWITCH_ACTIVE, borderColor: Colors.GREEN_SWITCH_ACTIVE}}><i className="fas fa-check mx-2"/> {` Guardar Evidencias`}</button>
                :
                <button className="btn btn-primary text-center px-2 py-1" style={{height: 35, backgroundColor: Colors.DARK_GRAY, borderColor: Colors.DARK_GRAY}}><i className="fas fa-check Mx-2"/> {` Guardar Evidencias`}</button>
            }
          </div>
        </div>
      </div>

      <div className="my-1 borderUploadDocument">

        <div className="py-2 px-4 d-flex justify-content-center align-items-center mt-2 borderBottomDashed">

          {
            stateImages?.length === 0 ?
              <h4 className="m-0 vertical-align-center">No tienes evidencias guardadas</h4>
              :
              <div className='w-100'>
                <h4 className="font-weight-bold fontSizeDropCurrentFiles">Archivos actuales</h4>
                <ul id="currentFiles">
                  {
                    stateImages?.map((item) => (
                      <li key={item.idTipo}>
                        <div className="d-flex flex-column align-items-center justify-content-center px-2">
                          <div className="position-relative">
                            <Zoom>
                              <img className="borderImg" src={
                                typeof item?.url === "string" ? item?.url?.includes('http')? item?.url : `${GlobalConstants.urlUploadImage}${item?.url}` : URL.createObjectURL(item?.url)
                              } style={{width: 100, height: 100, borderRadius: 10, objectFit: 'cover'}}/>
                            </Zoom>
                            <div className="d-flex justify-content-end align-items-center px-0 pb-3 position-absolute" style={{top:-10, right: -10}}>
                              <Tooltip title="Eliminar archivo" aria-label="eliminarArchivo">
                                <a onClick={() => removeCurrentFile(item)}
                                   className="icon-container-actions d-flex mr-0">
                                  <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
                                  <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times"/>
                                </a>
                              </Tooltip>
                            </div>
                          </div>
                          <p className="mb-0 mt-2 font-weight-bold">{item.nmTipo}</p>
                        </div>
                      </li>
                    ))
                  }
                </ul>
              </div>
          }

        </div>

        <section>
          <div className="text-center minHeight200 d-flex flex-column justify-content-center cursor-pointer" {...getRootProps({style})}>
            <input {...getInputProps()} />
            <p className="font-weight-bold mb-1" style={{color: Colors.DARK_GRAY}}>Arrastra hasta aqui las imagenes que desees o haz click aqui para seleccionarlas</p>
            <em className="font-weight-bold" style={{color: Colors.DARK_GRAY}}>(Solo *.jpeg and *.png imagenes son aceptadas)</em>
          </div>
          <aside className="px-3">
            {
              acceptedFiles?.length > 0 &&
              <>
                <h4 className="mt-3 font-weight-bold fontSizeDropFilesAccepted">Archivos aceptados</h4>
                <ul id="acceptedFiles">{stateAcceptedFiles}</ul>
              </>
            }
            {
              fileRejections?.length > 0 &&
              <>
                <h4 className="my-2 font-weight-bold fontSizeDropFilesRejected">Archivos rechazados</h4>
                <ul id="rejectedFiles">{fileRejectionItems}</ul>
              </>
            }
          </aside>
        </section>

      </div>

    </div>

  )

}

const FormClientesCRUD = ({isEditing, isAddMode, properties}) => {

  const generalServicesState = useSelector( state => state.generalServices )
  const { infoCli } = properties;
  const methods = useForm({defaultValues: {...infoCli, estadoCivil: isEmpty(infoCli?.estadoCivil) ? "0" : infoCli?.estadoCivil}});

  return(
    <FormProvider {...methods} >
        <div>

            <Tabs tabs={[
                {show: true, text: "Datos Básicos", value: "datosBasicos", icon: "fas fa-briefcase",
                    component: <DatosBasicos isAddMode={isAddMode} isEditing={isEditing} properties={properties} stateSelects={generalServicesState} />},
                {show: true, text: "Puntos de venta", value: "puntosVenta", icon: "fas fa-map-marked-alt",
                    component: <PuntosVenta isEditing={isEditing} properties={properties} stateSelects={generalServicesState} />},
                {show: true, text: "Evidencias", value: "evidencias", icon: "fas fa-camera-retro",
                    component: <Evidencias isEditing={isEditing} properties={properties} stateSelects={generalServicesState}/>}
                ]} defaultValue="datosBasicos" />

            <ModalCRUD id="modalCreateEditRutas" />

            <ModalCRUD id="modalPuntoVenta" />

        </div>
    </FormProvider>
    )

}

export default FormClientesCRUD;
